// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { Colors as OriginalColors } from "./colors";

export const Colors = { ...OriginalColors };

(Colors as any)["PrimaryMain"] = "#EC0000";
(Colors as any)["BackgroundBody"] = "#112234";
(Colors as any)["PrimaryContainerDark"] = "#071320";
(Colors as any)["HeadingText"] = "#EC0000";
(Colors as any)["TextPrimary"] = "#000000";
(Colors as any)["TextSecondary"] = "#000000";
(Colors as any)["TextContent"] = "#000000";
(Colors as any)["SecondaryMain"] = "#CCCCCC";
(Colors as any)["SecondaryDark"] = "#CCCCCC28";
(Colors as any)["TextDark"] = "#000000";
(Colors as any)["BodyText"] = "#000000"; // TODO: Find a medium between FFF and C0C7CB
(Colors as any)["InfoLight"] = "#ACE9FF";
(Colors as any)["PrimaryGradient"] =
  "linear-gradient(90deg, #C45CFF 0%, #A200FF 100%)";
